import 'semantic-ui-less/definitions/elements/button.less';import _default from './Button';
export { _default as default };